import { Version } from '@devstroupe/version/version';

export const DEVSTROUPE_VERSION = new Version('2.0.0').full;
